<script setup lang="ts">
const props = defineProps<{
  data: Education,
}>()
</script>

<template>
  <div>
    <layout-page-heading
      :title="props.data.title"
      :sub-title="props.data?.subTitle"
      :on-modal-page="true"
    >
      <div
        v-if="props.data.description"
        class="mt-0_25 text-center text-blue font-milling"
      >
        <core-rich-text
          :content="props.data.description"
        />
      </div>
    </layout-page-heading>

    <div
      v-if="props.data.coverImage"
      class="px-1 my-3"
    >
      <shared-image-carousel
        :slides="[props.data.coverImage]"
      />
    </div>

    <div
      v-if="props.data.participants && props.data.participants.length"
      class="px-1 my-3"
    >
      <div class="section-heading mb-0_35 <sm:mb-0_5 b-blue">
        {{ $t('label.participant', { count: props.data.participants.length }) }}
      </div>

      <SharedParticipants :venue="{ participants: { docs: props.data.participants } }" />
    </div>

    <shared-popup-block
      v-for="(block, index) in props.data?.content"
      :key="index"
      :block="block"
    />

    <div
      v-if="props.data?.events?.length"
      class="px-1 mt-3 mb-1"
    >
      <div
        class="section-heading mb-0_35 <sm:mb-0_5 b-blue"
      >
        {{ $t('label.event', { count: props.data?.events?.length }) }}
      </div>

      <shared-events
        :events="props.data?.events"
        view-option="modal"
        thumbnail-view-option="compact"
      />
    </div>
  </div>
</template>
